import { Select } from "antd"
import React, { useEffect, useState } from "react"
import ContractCustomerService from "src/services/CustomerContractService"
import DropdownService from "src/services/DropdownService"
import UserManagement from "src/services/UserManagement"

const removeVietnameseTones = str => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // bỏ dấu
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
}
// ADMIN/LEADER/STAFF
const SelectCustomer = ({
  value,
  onChange,
  disabled,
  style = { height: "36px" },
  type = "LEADER",
  position = null,
  positions = null,
  placeholder = "Chọn khách hàng",
  level,
  ignoreContracts = null
}) => {
  const [customerList, setCustomerList] = useState([])

  useEffect(() => {
    fetchCustomerList()
  }, [])

  const fetchCustomerList = async () => {
    try {
      // const type = ["LEADER"]
      const response = await DropdownService.getListAllCustomer({
        types: [type],
        is_locked: [0],
        positions: position ? [position] : positions,
        level: level,
        ignoreContracts: ignoreContracts,
      })
      setCustomerList(response.success || [])
    } catch (error) {
      console.error("Error fetching customer list:", error)
    }
  }

  return (
    <Select
      showSearch
      placeholder={placeholder}
      title={placeholder}
      allowClear
      value={value}
      onChange={onChange}
      filterOption={(input, option) => {
        const inputNormalized = removeVietnameseTones(input)
        const optionText = removeVietnameseTones(option.children)
        return optionText.includes(inputNormalized)
      }}
      style={style}
      disabled={disabled}
    >
      {customerList.map(customer => (
        <Select.Option key={customer.ID} value={customer.ID}>
          {customer.fullname}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectCustomer
